import React from "react";
import { Collapse } from "react-collapse";

import { FlightStream } from "shared/gol-api/types/flightSearch";

import FormattedMessage from "@components/UI/FormattedMessage";

import FormatDuration from "../Formatters/FormatDuration";
import FlightDetailSegment from "./FlightDetailSegment";
import FlightDetailStreamTransfer from "./FlightDetailStreamTransfer";

type Props = {
  selectedFlightStream: FlightStream;
  show?: boolean;
};

export default function FlightDetailStream({
  selectedFlightStream,
  show,
}: Props) {
  const flightSegments = selectedFlightStream.FlightSegments.FlightSegment;

  return (
    <div>
      <Collapse isOpened={show}>
        <div>
          <div className="flight-detail-duration">
            <FormattedMessage id="FlightDetail.wholeTime" />:{" "}
            <FormatDuration
              showNothingIfNotDefined
              duration={selectedFlightStream.JourneyDuration}
            />
          </div>
          {flightSegments.map((oFlightSegment, index) => (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={`${oFlightSegment.FlightNumber}-${index}`}
            >
              <FlightDetailSegment
                underTransfer={index !== 0}
                oFlightSegment={oFlightSegment}
              />
              {index < flightSegments.length - 1 && (
                <FlightDetailStreamTransfer
                  arrivalDateTime={oFlightSegment.ArrivalDateTime}
                  departureDateTimeNextSegment={
                    flightSegments[index + 1].DepartureDateTime
                  }
                />
              )}
            </div>
          ))}
          <div />
        </div>
      </Collapse>
    </div>
  );
}
